import * as WpsTypes from 'DVWebNodeWpsRuntime'
import { createMergeReducer } from '../utils/reducer'

export type TitleIdToCreative = {
  [titleId: string]: WpsTypes.atv.wps.CreativesModelProps | undefined
}

export const reducer = createMergeReducer(
  t => t.creative,
  {} as TitleIdToCreative
)
